import { render, staticRenderFns } from "./FormBuilderSidebar.vue?vue&type=template&id=58f42f02&scoped=true"
import script from "./FormBuilderSidebar.vue?vue&type=script&lang=js"
export * from "./FormBuilderSidebar.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderSidebar.vue?vue&type=style&index=0&id=58f42f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f42f02",
  null
  
)

export default component.exports